// Shared look of the colourful module tiles (Dashboard shortcuts, Settings tiles).

// Brand squircle shape (the superellipse path extracted from the module-icon
// SVGs). Applied as a CSS mask so a per-module gradient fills the exact same
// shape as the reference icons — instead of a circular-corner rounded square.
const SQUIRCLE_MASK =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 72' preserveAspectRatio='none'%3E%3Cpath d='M.25,36C.25,10,10,.25,36,.25s35.75,9.75,35.75,35.75-9.75,35.75-35.75,35.75S.25,62,.25,36Z' fill='black'/%3E%3C/svg%3E\")";

export const squircleStyle = {
    WebkitMaskImage: SQUIRCLE_MASK,
    maskImage: SQUIRCLE_MASK,
    WebkitMaskSize: '100% 100%',
    maskSize: '100% 100%',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
};

/** Vibrant two-stop gradient for one hue (0-359). */
export const linkGradient = (hue) =>
    `linear-gradient(135deg, hsl(${hue} 76% 57%), hsl(${(hue + 16) % 360} 76% 45%))`;
